import './MultipleChoice.scss';
import { IconArrowMedium } from '../icons/svgs';
import MultipleChoicePreview from '../preview/MultipleChoicePreview';
import NextAction from '../actions/NextAction';
class MultipleChoiceTemplate {
    structures() {
        return {
            esay : {
                type:'textarea',
                label: 'Question',
                placeholder: 'Question to ask',
                helpText: 'Multiple choice question that required user need to mark several answer'
            },
            answer : {
                label: 'Answer',
                haveValue:true,
                type:'repeater',   // max 4 option
                repeaterType: 'input',  // default repeaterType=input
                maxOption: 4,
                struct: {
                    text: {
                        type: 'text'
                    },
                    correct: {
                        type: 'radio',
                        // label: 'Correct Answer?',
                        trueLabel : 'Marked as the correct answer',
                        falseLabel: 'Wrong answer'
                    }
                }
            }
        }
    }

    type() {
        return 'MultipleChoiceTemplate';
    }

    name() {
        return 'Multiple Choice';
    }
    iconType() {
        return 'multiplechoice';
    }
    canRearrange(){
        return true;
    }
    canRenameLabel(){
        return true;
    }
    imageTemplate(){
        return (
            <div>
                <img src={require('../assets/img/template-image-multiple-choice.jpg')} className='img-fluid' alt='question template'/>
            </div>
        );
    }
    textHighlight(){
        return (
            <div>
                <span className='font-weight-700 text-dark'>Make a test</span>
                <span className='text-muted'> the student of how well they learning so far.</span>
            </div>
        );
    }

    getDuration(){
        return 300;
    }

    render(data, index) {
        return (
            <MultipleChoicePreview data={data} index={index} structures={this.structures()}/>
        )
    }

    actions(data, index){
        return (
            <NextAction label='Next' icon={<IconArrowMedium/>}/>
        );
    }
}


export default MultipleChoiceTemplate;
